import { useRouter } from "~/hooks/useRouter";
import CreateCaseButton from "~/components/practice/case/CreateCaseButton";
import NavBar from "./NavBar";
import { useFeatureFlags } from "~/hooks/feature-flags";
import { useMemo } from "react";

type NavItem = {
  name: string;
  href: string;
  count?: number;
  children?: React.ReactNode;
};

export default function AscNavBar() {
  const { billing, scheduling, reports, emrFeatures, materialsDemo } = useFeatureFlags();
  const router = useRouter();

  const navItems: NavItem[] = useMemo(
    () =>
      [
        ...(((scheduling && [
          { name: "Pending", href: "/facility/cases/pending" },
          { name: "Canceled", href: "/facility/cases/canceled" },
          {
            name: "Cases",
            href: "/facility/cases",
            children: (
              <CreateCaseButton
                variant="primary"
                outline={false}
                asLink
                size="sm"
                onCreated={(id) => router.push(`/facility/cases/${id}`)}
              />
            ),
          },
          { name: "Calendar", href: "/facility/calendar" },
          {
            name: "Status Tracker",
            href: "/facility/status-tracker",
          },
          { name: "Patients", href: "/patients" },
        ]) ||
          []) satisfies NavItem[]),
        ...(((materialsDemo && [{ name: "Materials", href: "/mat-demo" }]) ||
          []) satisfies NavItem[]),
        ...(((billing && [{ name: "Billing", href: "/billing/cases" }]) || []) satisfies NavItem[]),
        ...(((reports && [{ name: "Reports", href: "/reports" }]) || []) satisfies NavItem[]),
        ...(((emrFeatures && [{ name: "Charts", href: "/emr/encounters" }]) ||
          []) satisfies NavItem[]),
        { name: "Admin", href: "/facility/admin/center-info" },
      ] satisfies NavItem[],
    [router, billing, scheduling, reports, emrFeatures, materialsDemo]
  );

  return <NavBar navItems={navItems} />;
}
